var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlyphLogoMay2016Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 503.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m251.9,45.4c67.3,0,75.2.3,101.8,1.5,24.6,1.1,37.9,5.2,46.8,8.7,11.8,4.6,20.2,10,29,18.8s14.3,17.2,18.8,29c3.4,8.9,7.6,22.2,8.7,46.8,1.2,26.6,1.5,34.5,1.5,101.8s-.3,75.2-1.5,101.8c-1.1,24.6-5.2,37.9-8.7,46.8-4.6,11.8-10,20.2-18.8,29s-17.2,14.3-29,18.8c-8.9,3.4-22.2,7.6-46.8,8.7-26.6,1.2-34.5,1.5-101.8,1.5s-75.2-.3-101.8-1.5c-24.6-1.1-37.9-5.2-46.8-8.7-11.8-4.6-20.2-10-29-18.8s-14.3-17.2-18.8-29c-3.4-8.9-7.6-22.2-8.7-46.8-1.2-26.6-1.5-34.5-1.5-101.8s.3-75.2,1.5-101.8c1.1-24.6,5.2-37.9,8.7-46.8,4.6-11.8,10-20.2,18.8-29s17.2-14.3,29-18.8c8.9-3.4,22.2-7.6,46.8-8.7,26.6-1.3,34.5-1.5,101.8-1.5m0-45.4c-68.4,0-77,.3-103.9,1.5-26.8,1.2-45.1,5.5-61.1,11.7-16.6,6.4-30.6,15.1-44.6,29.1s-22.6,28.1-29.1,44.6c-6.2,16-10.5,34.3-11.7,61.2-1.2,26.8-1.5,35.4-1.5,103.8s.3,77,1.5,103.9c1.2,26.8,5.5,45.1,11.7,61.2,6.4,16.6,15.1,30.6,29.1,44.6s28.1,22.6,44.6,29.1c16,6.2,34.3,10.5,61.2,11.7s35.4,1.5,103.9,1.5,77-.3,103.9-1.5c26.8-1.2,45.1-5.5,61.2-11.7,16.6-6.4,30.6-15.1,44.6-29.1s22.6-28.1,29.1-44.6c6.2-16,10.5-34.3,11.7-61.2,1.2-26.9,1.5-35.4,1.5-103.9s-.3-77-1.5-103.9c-1.2-26.8-5.5-45.1-11.7-61.2-6.4-16.6-15.1-30.6-29.1-44.6s-28.1-22.6-44.6-29.1c-16-6.2-34.3-10.5-61.2-11.7-27-1.1-35.6-1.4-104-1.4h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m251.9,122.5c-71.4,0-129.4,57.9-129.4,129.4s58,129.4,129.4,129.4,129.4-58,129.4-129.4-58-129.4-129.4-129.4Zm0,213.4c-46.4,0-84-37.6-84-84s37.6-84,84-84,84,37.6,84,84-37.6,84-84,84Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 386.4,
    cy: 117.4,
    r: 30.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlyphLogoMay2016Black);
export default __webpack_public_path__ + "static/media/glyph-logo_May2016-black.cc174a4dd5869a34ebff2e3e010fcd1a.svg";
export { ForwardRef as ReactComponent };